"use client";
import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledCloseIconButton = styled(IconButton, {
  shouldForwardProp: () => true
})`
    background: none !important;
    float: right;
    padding: 0;
    :focus-visible {
        outline: 2px solid Highlight;
        outline: 2px auto -webkit-focus-ring-color;
        border-radius: 0;
    }
`;
export {
  StyledCloseIconButton
};
